// extracted by mini-css-extract-plugin
module.exports = {"nav":"ProductItemMenu_nav__32JVQ","navItem":"ProductItemMenu_navItem__1Hcdv","button":"ProductItemMenu_button__31cIK","active":"ProductItemMenu_active__2mMAO"};